/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import moment from "moment";
import MainContainer from "../../layout/MainContainer";
import {
  Card,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Button,
  TableBody,
  Menu,
  MenuItem,
  FormControl,
  Modal,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import Grid from "@mui/material/Grid";
import { Loader, showError, showToast } from "../../constants";
import { Pagination } from "../../components";
import { isValidInput } from "../../utils/validations";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import BarChartIcon from "@mui/icons-material/BarChart";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import { Getcouponcode, Editcouponcode, Createcouponcode, GetCouponStats } from "../../services/coupon";

interface CouponCode {
  _id: string;
  coupon_code: string;
  amount: number;
  expiry_date: string;
  status: string;
  product_id: string;
  createdAt: string;
  updatedAt: string;
  redemption_count: number;
}

interface CouponFormData {
  coupon_code: string;
  amount: string;
  expiry_date: any;
  product_id: string;
  status: string;
}

interface CouponRedemption {
  user_name: string;
  user_email: string;
  redeemed_at: string;
}

interface CouponStats {
  total_redemptions: number;
  recent_redemptions: CouponRedemption[];
}

const initialFormData: CouponFormData = {
  coupon_code: "",
  amount: "",
  expiry_date: null,
  product_id: "",
  status: "active",
};

const modalStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", sm: 480 },
  maxHeight: "90vh",
  overflowY: "auto" as const,
  bgcolor: "#ffffff",
  boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
  p: 4,
  borderRadius: "16px",
  outline: "none",
  border: "1px solid #f1f5f9",
};

const CouponCodes = () => {
  const [allCoupons, setAllCoupons] = useState<CouponCode[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [opened, setOpened] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const [startDate, setStartDate] = useState<any | null>(null);
  const [endDate, setEndDate] = useState<any | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  let totalPages = Math.ceil(totalCount / 10);

  // Modal states
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [editingId, setEditingId] = useState<string>("");
  const [formData, setFormData] = useState<CouponFormData>(initialFormData);
  
  // Actions menu state
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedCoupon, setSelectedCoupon] = useState<CouponCode | null>(null);

  // Confirmation dialog state
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [confirmAction, setConfirmAction] = useState<{ newStatus: string; id: string } | null>(null);

  // Stats modal state
  const [statsModalOpen, setStatsModalOpen] = useState<boolean>(false);
  const [statsLoading, setStatsLoading] = useState<boolean>(false);
  const [couponStats, setCouponStats] = useState<CouponStats | null>(null);
  const [statsCouponCode, setStatsCouponCode] = useState<string>("");

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, coupon: CouponCode) => {
    setAnchorEl(event.currentTarget);
    setSelectedCoupon(coupon);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedCoupon(null);
  };

  const handleConfirmStatusChange = () => {
    if (confirmAction) {
      handleStatusChange(confirmAction.newStatus, confirmAction.id);
    }
    setConfirmOpen(false);
    setConfirmAction(null);
  };

  const handleCancelConfirm = () => {
    setConfirmOpen(false);
    setConfirmAction(null);
  };

  const handleViewStats = async (coupon: CouponCode) => {
    try {
      setStatsCouponCode(coupon.coupon_code);
      setStatsModalOpen(true);
      setStatsLoading(true);
      setCouponStats(null);

      const response: any = await GetCouponStats(coupon._id);

      if (response?.status === 200) {
        setCouponStats(response?.data || null);
      } else {
        showError("Failed to fetch coupon stats");
      }
      setStatsLoading(false);
    } catch (error: any) {
      setStatsLoading(false);
      showError(error?.data?.message || "Failed to fetch coupon stats");
    }
  };

  const handleCloseStats = () => {
    setStatsModalOpen(false);
    setCouponStats(null);
    setStatsCouponCode("");
  };

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getcouponcode = async () => {
    try {
      setLoading(true);
      const response: any = await Getcouponcode({
        limit: 10,
        page: page,
        search: debouncedSearchTerm,
        ...(status && { status }),
        ...(startDate && { startDate: dayjs(startDate).toISOString() }),
        ...(endDate && { endDate: dayjs(endDate).toISOString() }),
      });

      if (response?.status === 200) {
        setLoading(false);
        setAllCoupons(response?.data?.list || []);
        setTotalCount(response?.data?.totalitems || 0);
      } else {
        setLoading(false);
        setAllCoupons([]);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "Failed to fetch coupon codes");
    }
  };

  const resetValues = () => {
    setStatus("");
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    getcouponcode();
    setOpened(false);
  };

  const applyFilter = () => {
    setPage(1);
    getcouponcode();
    setOpened(false);
  };

  const handleStatusChange = async (newStatus: string, id: string) => {
    try {
      setLoading(true);

      const response: any = await Editcouponcode({
        _id: id,
        status: newStatus,
      });

      if (response?.status === 200) {
        setLoading(false);
        showToast("Status updated successfully");
        let coupons = [...allCoupons];
        let idx = -1;
        idx = coupons?.findIndex((item) => item?._id === id);
        if (idx > -1) {
          coupons[idx] = {
            ...coupons[idx],
            status: newStatus,
          };
        }
        setAllCoupons([...coupons]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showError("Something went wrong");
      console.log(error);
    }
  };

  const handleOpenModal = (coupon?: CouponCode) => {
    if (coupon) {
      setIsEditing(true);
      setEditingId(coupon._id);
      setFormData({
        coupon_code: coupon.coupon_code,
        amount: coupon.amount.toString(),
        expiry_date: coupon.expiry_date ? dayjs(coupon.expiry_date) : null,
        product_id: coupon.product_id,
        status: coupon.status,
      });
    } else {
      setIsEditing(false);
      setEditingId("");
      setFormData(initialFormData);
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setIsEditing(false);
    setEditingId("");
    setFormData(initialFormData);
  };

  const handleFormChange = (field: keyof CouponFormData, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.coupon_code.trim()) {
      showError("Please enter a coupon code");
      return;
    }
    if (!formData.amount || Number(formData.amount) <= 0) {
      showError("Please enter a valid amount");
      return;
    }
    if (!Number.isInteger(Number(formData.amount))) {
      showError("Amount must be a whole number (no decimals)");
      return;
    }
    if (!formData.product_id.trim()) {
      showError("Please enter a product ID");
      return;
    }

    try {
      setLoading(true);

      const payload: any = {
        coupon_code: formData.coupon_code.toUpperCase(),
        amount: Number(formData.amount),
        product_id: formData.product_id,
        status: formData.status,
        ...(isEditing && { _id: editingId }),
      };

      if (formData.expiry_date) {
        payload.expiry_date = dayjs(formData.expiry_date).toISOString();
      }

      let response: any;

      if (isEditing) {
        response = await Editcouponcode(payload);
      } else {
        response = await Createcouponcode(payload);
      }

      if (response?.status === 200 || response?.status === 201) {
        showToast(
          isEditing
            ? "Coupon code updated successfully"
            : "Coupon code created successfully"
        );
        handleCloseModal();
        getcouponcode();
      } else {
        showError(response?.message || "Something went wrong");
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "Something went wrong");
      console.log(error);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => setDebouncedSearchTerm(searchTerm), 1000);
    return () => clearTimeout(timerId);
  }, [searchTerm]);

  useEffect(() => {
    getcouponcode();
  }, [debouncedSearchTerm, page]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MainContainer>
        <Loader isLoad={loading} />
        <div onClick={() => setOpened(false)} className="main_loyout">
          <div className="dashboard">
            <div className="heading-bread">
              <h1 className="mn_hdng">Coupon Codes</h1>
            </div>
          </div>
          <Card className="cards">
            <Box className="cards_header">
              <Grid
                container
                spacing={2}
                sx={{ mb: 1 }}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={12} md="auto">
                  <TextField
                    placeholder="Search by Coupon Code"
                    value={searchTerm}
                    size="small"
                    onChange={(e) => {
                      if (isValidInput(e.target.value)) {
                        setPage(1);
                        setSearchTerm(e.target.value);
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ width: { xs: "100%", md: 280 } }}
                  />
                </Grid>
                <Grid item xs={12} md="auto">
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: { xs: "flex-start", md: "flex-end" },
                    }}
                  >
                    <Button
                      onClick={() => handleOpenModal()}
                      variant="contained"
                      startIcon={<AddIcon />}
                      sx={{ height: 40 }}
                    >
                      Add Coupon
                    </Button>
                    <div className="parent-box">
                      <Button
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setOpened(true);
                        }}
                        variant="contained"
                        sx={{ height: 40 }}
                      >
                        Filter
                      </Button>
                      {opened ? (
                        <div
                          onClick={(e) => e.stopPropagation()}
                          className="filter-options"
                        >
                          <h3>Filter Options</h3>
                          <div className="filter-div">
                            <FormControl fullWidth>
                              <label>Status</label>
                              <select
                                onChange={(val) => setStatus(val.target.value)}
                                value={status}
                                name="status"
                                id="status"
                              >
                                <option value="">Any</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </select>
                            </FormControl>
                            <FormControl fullWidth>
                              <label>Period</label>
                              <div
                                className="range-picker"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "20px",
                                }}
                              >
                                <DatePicker
                                  sx={{ height: "40px" }}
                                  value={startDate}
                                  onChange={(val) => {
                                    setStartDate(val);
                                  }}
                                  format="DD/MM/YYYY"
                                  label="From"
                                />
                                <DatePicker
                                  sx={{ height: "40px" }}
                                  value={endDate}
                                  minDate={startDate}
                                  onChange={(val) => {
                                    setEndDate(val);
                                  }}
                                  disableFuture
                                  format="DD/MM/YYYY"
                                  label="Till"
                                />
                              </div>
                            </FormControl>

                            <div className="button-div">
                              <Button 
                                onClick={resetValues} 
                                id="basic-button"
                                sx={{
                                  color: "#64748b",
                                  fontWeight: 600,
                                  textTransform: "none",
                                  "&:hover": {
                                    backgroundColor: "#f1f5f9",
                                  },
                                }}
                              >
                                Reset
                              </Button>
                              <Button
                                onClick={applyFilter}
                                id="basic-button"
                                variant="contained"
                                sx={{
                                  background: "linear-gradient(135deg, #1c9aaa 0%, #167a88 100%)",
                                  boxShadow: "0 4px 14px 0 rgba(28, 154, 170, 0.25)",
                                  borderRadius: "8px",
                                  textTransform: "none",
                                  fontWeight: 600,
                                  "&:hover": {
                                    background: "linear-gradient(135deg, #167a88 0%, #115b66 100%)",
                                  },
                                }}
                              >
                                Apply
                              </Button>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <TableContainer className="table_container">
              <Box className="heading"></Box>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">CODE</TableCell>
                    <TableCell align="center">DISCOUNT</TableCell>
                    <TableCell align="center">PRODUCT</TableCell>
                    <TableCell align="center">REDEMPTIONS</TableCell>
                    <TableCell align="center">EXPIRY DATE</TableCell>
                    <TableCell align="center">STATUS</TableCell>
                    <TableCell align="center">ACTIONS</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {allCoupons?.length ? (
                    allCoupons?.map((item: CouponCode) => {
                      return (
                        <TableRow key={item._id}>
                          <TableCell align="left">
                            {item?.coupon_code || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            ₹{item?.amount || 0}
                          </TableCell>
                          <TableCell align="center">
                            {item?.product_id || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {item?.redemption_count ?? 0}
                          </TableCell>
                          <TableCell align="center">
                            {item?.expiry_date
                              ? moment(item?.expiry_date).format(
                                  "MMM DD, YYYY"
                                )
                              : "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            <span
                              className={`status ${item?.status === "active" ? "Active" : "Disabled"}`}
                            >
                              {item?.status === "active" ? "Active" : "Inactive"}
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, item)}
                              sx={{
                                backgroundColor: "#f1f5f9",
                                "&:hover": {
                                  backgroundColor: "#e2e8f0",
                                },
                              }}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={7}
                        sx={{ color: "#051140" }}
                      >
                        No Coupon Codes Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            
            {/* Actions Menu */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
                  mt: 1,
                  minWidth: 160,
                  borderRadius: "10px",
                  "& .MuiMenuItem-root": {
                    padding: "10px 16px",
                    fontSize: "13px",
                    fontWeight: 500,
                    gap: "10px",
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  if (selectedCoupon) handleOpenModal(selectedCoupon);
                  handleMenuClose();
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" sx={{ color: "#64748b" }} />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              
              <MenuItem
                onClick={() => {
                  if (selectedCoupon) {
                    setConfirmAction({
                      newStatus: selectedCoupon.status === "active" ? "inactive" : "active",
                      id: selectedCoupon._id,
                    });
                    setConfirmOpen(true);
                  }
                  handleMenuClose();
                }}
              >
                <ListItemIcon>
                  {selectedCoupon?.status === "active" ? (
                    <ToggleOffIcon fontSize="small" sx={{ color: "#ef4444" }} />
                  ) : (
                    <ToggleOnIcon fontSize="small" sx={{ color: "#22c55e" }} />
                  )}
                </ListItemIcon>
                <ListItemText>
                  {selectedCoupon?.status === "active" ? "Deactivate" : "Activate"}
                </ListItemText>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  if (selectedCoupon) handleViewStats(selectedCoupon);
                  handleMenuClose();
                }}
              >
                <ListItemIcon>
                  <BarChartIcon fontSize="small" sx={{ color: "#64748b" }} />
                </ListItemIcon>
                <ListItemText>View Stats</ListItemText>
              </MenuItem>
            </Menu>
          </Card>
          <Pagination
            module={allCoupons || []}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        </div>

        {/* Add/Edit Coupon Modal */}
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="coupon-modal-title"
        >
          <Box sx={modalStyle}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={3}
            >
              <Typography
                id="coupon-modal-title"
                variant="h6"
                component="h2"
                sx={{ 
                  color: "#1e293b", 
                  fontWeight: 700,
                  fontSize: "18px",
                  letterSpacing: "-0.02em",
                }}
              >
                {isEditing ? "Edit Coupon Code" : "Add New Coupon Code"}
              </Typography>
              <IconButton onClick={handleCloseModal} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box display="flex" flexDirection="column" gap={2.5}>
              <TextField
                label="Coupon Code"
                value={formData.coupon_code}
                onChange={(e) =>
                  handleFormChange("coupon_code", e.target.value.toUpperCase())
                }
                fullWidth
                placeholder="e.g., SAVE50"
                inputProps={{ style: { textTransform: "uppercase" } }}
              />

              <TextField
                label="Amount (₹)"
                type="number"
                value={formData.amount}
                onChange={(e) => handleFormChange("amount", e.target.value)}
                fullWidth
                placeholder="e.g., 199"
              />

              <DatePicker
                label="Expiry Date"
                value={formData.expiry_date}
                onChange={(val) => handleFormChange("expiry_date", val)}
                format="DD/MM/YYYY"
                minDate={dayjs()}
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    paddingRight: "14px",
                  },
                  "& .MuiInputAdornment-root": {
                    marginLeft: 0,
                  },
                }}
              />

              <TextField
                label="Product ID"
                value={formData.product_id}
                onChange={(e) => handleFormChange("product_id", e.target.value)}
                fullWidth
                placeholder="e.g., annual_insider_subscription_199"
              />

              <FormControl fullWidth>
                <TextField
                  select
                  label="Status"
                  value={formData.status}
                  onChange={(e) => handleFormChange("status", e.target.value)}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </TextField>
              </FormControl>

              <Box display="flex" gap={2} mt={2} justifyContent="flex-end">
                <Button
                  onClick={handleCloseModal}
                  variant="outlined"
                  sx={{
                    color: "#64748b",
                    borderColor: "#e2e8f0",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": { 
                      borderColor: "#cbd5e1",
                      backgroundColor: "#f8fafc",
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    background: "linear-gradient(135deg, #1c9aaa 0%, #167a88 100%)",
                    boxShadow: "0 4px 14px 0 rgba(28, 154, 170, 0.25)",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": { 
                      background: "linear-gradient(135deg, #167a88 0%, #115b66 100%)",
                      boxShadow: "0 6px 20px rgba(28, 154, 170, 0.35)",
                    },
                  }}
                >
                  {isEditing ? "Update" : "Create"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
        {/* Confirmation Dialog */}
        <Modal
          open={confirmOpen}
          onClose={handleCancelConfirm}
          aria-labelledby="confirm-modal-title"
        >
          <Box sx={{ ...modalStyle, width: { xs: "90vw", sm: 400 } }}>
            <Typography
              id="confirm-modal-title"
              variant="h6"
              component="h2"
              sx={{
                color: "#1e293b",
                fontWeight: 700,
                fontSize: "18px",
                mb: 2,
              }}
            >
              Confirm Status Change
            </Typography>
            <Typography sx={{ color: "#475569", fontSize: "14px", mb: 3 }}>
              Are you sure you want to{" "}
              <strong>
                {confirmAction?.newStatus === "active" ? "activate" : "deactivate"}
              </strong>{" "}
              this coupon code?
            </Typography>
            <Box display="flex" gap={2} justifyContent="flex-end">
              <Button
                onClick={handleCancelConfirm}
                variant="outlined"
                sx={{
                  color: "#64748b",
                  borderColor: "#e2e8f0",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    borderColor: "#cbd5e1",
                    backgroundColor: "#f8fafc",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleConfirmStatusChange}
                variant="contained"
                sx={{
                  background:
                    confirmAction?.newStatus === "active"
                      ? "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)"
                      : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    background:
                      confirmAction?.newStatus === "active"
                        ? "linear-gradient(135deg, #16a34a 0%, #15803d 100%)"
                        : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                  },
                }}
              >
                {confirmAction?.newStatus === "active" ? "Activate" : "Deactivate"}
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Stats Modal */}
        <Modal
          open={statsModalOpen}
          onClose={handleCloseStats}
          aria-labelledby="stats-modal-title"
        >
          <Box sx={{ ...modalStyle, width: { xs: "90vw", sm: 520 } }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={3}
            >
              <Typography
                id="stats-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  color: "#1e293b",
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                Stats: {statsCouponCode}
              </Typography>
              <IconButton onClick={handleCloseStats} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            {statsLoading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress size={32} sx={{ color: "#1c9aaa" }} />
              </Box>
            ) : couponStats ? (
              <Box>
                <Box
                  sx={{
                    p: 2,
                    mb: 3,
                    borderRadius: "12px",
                    backgroundColor: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    display: "inline-block",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "12px", color: "#15803d", fontWeight: 600 }}
                  >
                    Total Redemptions
                  </Typography>
                  <Typography
                    sx={{ fontSize: "28px", fontWeight: 700, color: "#166534" }}
                  >
                    {couponStats.total_redemptions}
                  </Typography>
                </Box>

                <Divider sx={{ mb: 2 }} />

                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#334155",
                    mb: 1.5,
                  }}
                >
                  Recent Redemptions
                </Typography>

                {couponStats.recent_redemptions.length > 0 ? (
                  <Box sx={{ maxHeight: 260, overflowY: "auto" }}>
                    {couponStats.recent_redemptions.map(
                      (r: CouponRedemption, idx: number) => (
                        <Box
                          key={idx}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            py: 1.2,
                            px: 1,
                            borderBottom:
                              idx < couponStats.recent_redemptions.length - 1
                                ? "1px solid #f1f5f9"
                                : "none",
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "13px",
                                fontWeight: 600,
                                color: "#1e293b",
                              }}
                            >
                              {r.user_name}
                            </Typography>
                            <Typography
                              sx={{ fontSize: "12px", color: "#94a3b8" }}
                            >
                              {r.user_email}
                            </Typography>
                          </Box>
                          <Typography sx={{ fontSize: "12px", color: "#94a3b8" }}>
                            {moment(r.redeemed_at).format("MMM DD, YYYY h:mm A")}
                          </Typography>
                        </Box>
                      )
                    )}
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#94a3b8",
                      textAlign: "center",
                      py: 3,
                    }}
                  >
                    No redemptions yet
                  </Typography>
                )}
              </Box>
            ) : (
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#94a3b8",
                  textAlign: "center",
                  py: 3,
                }}
              >
                Failed to load stats
              </Typography>
            )}
          </Box>
        </Modal>
      </MainContainer>
    </LocalizationProvider>
  );
};

export default CouponCodes;
